import React, { useEffect, createElement } from 'react';
import { CheckCircleIcon, AlertTriangleIcon, BotIcon, LightbulbIcon, SmartphoneIcon, RocketIcon, ZapIcon, CalendarIcon, PhoneIcon, MapPinIcon, PenLineIcon, MailIcon, QuoteIcon, StarIcon } from 'lucide-react';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';
declare global {
  interface Window {
    fbq: any;
  }
}
export function LlamadaConfirmationPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('track', 'Schedule');
  }, []);
  return <div className="min-h-screen bg-black text-white font-sans overflow-x-hidden" data-id="element-1521">
      {/* Meta Pixel Noscript */}
      <noscript data-id="element-1522">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=Schedule&noscript=1" alt="" data-id="element-1523" />
      </noscript>

      {/* HERO BANNER */}
      <div className="bg-gradient-to-r from-[#00f7fc]/20 to-[#00d7dc]/10 border-b border-[#00f7fc]/30 py-10 md:py-16 px-4" data-id="element-1524">
        <div className="max-w-3xl mx-auto text-center" data-id="element-1525">
          <div className="flex justify-center mb-5" data-id="element-1526">
            <div className="w-20 h-20 bg-[#00f7fc]/10 border-2 border-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-1527">
              <CheckCircleIcon className="w-10 h-10 text-[#00f7fc]" data-id="element-1528" />
            </div>
          </div>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-black uppercase leading-tight tracking-tight mb-4" data-id="element-1529">
            Tu Llamada Está <span className="text-[#00f7fc]" data-id="element-1530">Confirmada</span>
          </h1>
          <p className="text-base md:text-lg text-gray-300 flex items-center justify-center gap-2" data-id="element-1531">
            <MailIcon className="w-5 h-5 text-[#00f7fc] flex-shrink-0" data-id="element-1532" />
            Revisa tu email para los detalles de conexión
          </p>
        </div>
      </div>

      <main className="max-w-4xl mx-auto px-4 py-10 md:py-16 space-y-12 md:space-y-16" data-id="element-1533">
        {/* IMPORTANT WARNING */}
        <section data-id="element-1534">
          <div className="bg-yellow-500/10 border-2 border-yellow-500/40 rounded-2xl p-6 md:p-8" data-id="element-1535">
            <div className="flex items-start gap-4" data-id="element-1536">
              <div className="flex-shrink-0 w-10 h-10 bg-yellow-500/20 rounded-full flex items-center justify-center" data-id="element-1537">
                <AlertTriangleIcon className="w-5 h-5 text-yellow-400" data-id="element-1538" />
              </div>
              <div data-id="element-1539">
                <h2 className="text-lg md:text-xl font-black uppercase tracking-wide text-yellow-400 mb-2" data-id="element-1540">
                  IMPORTANTE: Lee Esto Antes de Cerrar Esta Página
                </h2>
                <p className="text-gray-200 text-base md:text-lg leading-relaxed" data-id="element-1541">
                  Estás A <span className="font-black text-white" data-id="element-1542">UN PASO</span>{' '}
                  de Descubrir El Sistema de IA Que Está Cambiando Negocios en
                  Miami
                </p>
                <p className="text-gray-400 mt-3 text-sm md:text-base leading-relaxed" data-id="element-1543">
                  En tu llamada, te mostraremos exactamente cómo usar
                  herramientas de inteligencia artificial para construir un
                  negocio digital real, desde cero, sin experiencia previa.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* WHAT WILL HAPPEN ON YOUR CALL */}
        <section data-id="element-1544">
          <div className="text-center mb-8" data-id="element-1545">
            <div className="inline-flex items-center gap-2 bg-[#00f7fc]/10 border border-[#00f7fc]/30 rounded-full px-4 py-2 mb-4" data-id="element-1546">
              <CheckCircleIcon className="w-4 h-4 text-[#00f7fc]" data-id="element-1547" />
              <span className="text-sm font-semibold text-[#00f7fc] uppercase tracking-wide" data-id="element-1548">
                Lo Que Va a Pasar En Tu Llamada
              </span>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-4" data-id="element-1549">
            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4" data-id="element-1550">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-1551">
                <BotIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-1552" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-1553">
                Te mostraremos el sistema exacto de{' '}
                <span className="font-bold text-white" data-id="element-1554">
                  48 Horas AI Cash Machine
                </span>
              </p>
            </div>

            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4" data-id="element-1555">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-1556">
                <LightbulbIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-1557" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-1558">
                Aprenderás cómo la IA puede{' '}
                <span className="font-bold text-white" data-id="element-1559">
                  transformar tu negocio
                </span>{' '}
                desde hoy
              </p>
            </div>

            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4" data-id="element-1560">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-1561">
                <SmartphoneIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-1562" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-1563">
                Todo desde tu{' '}
                <span className="font-bold text-white" data-id="element-1564">celular o laptop</span>,
                sin oficina ni empleados
              </p>
            </div>

            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4" data-id="element-1565">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-1566">
                <RocketIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-1567" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-1568">
                <span className="font-bold text-white" data-id="element-1569">
                  Sin experiencia técnica
                </span>{' '}
                requerida
              </p>
            </div>

            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-5 flex items-start gap-4 md:col-span-2" data-id="element-1570">
              <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc]/10 rounded-lg flex items-center justify-center" data-id="element-1571">
                <ZapIcon className="w-5 h-5 text-[#00f7fc]" data-id="element-1572" />
              </div>
              <p className="text-gray-200 text-sm md:text-base leading-relaxed" data-id="element-1573">
                Un sistema diseñado para{' '}
                <span className="font-bold text-white" data-id="element-1574">
                  implementarse rápidamente
                </span>
              </p>
            </div>
          </div>
        </section>

        {/* BEFORE YOUR CALL - STEPS */}
        <section data-id="element-1575">
          <div className="bg-gray-900/50 border border-gray-800 rounded-2xl p-6 md:p-10" data-id="element-1576">
            <div className="flex items-center gap-3 mb-8" data-id="element-1577">
              <div className="w-8 h-8 bg-[#00f7fc]/10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-1578">
                <AlertTriangleIcon className="w-4 h-4 text-[#00f7fc]" data-id="element-1579" />
              </div>
              <h2 className="text-xl md:text-2xl font-black uppercase tracking-tight" data-id="element-1580">
                Antes de Tu Llamada, Haz Esto{' '}
                <span className="text-[#00f7fc]" data-id="element-1581">Ahora</span>
              </h2>
            </div>

            <div className="space-y-5" data-id="element-1582">
              {/* Step 1 */}
              <div className="flex items-start gap-4" data-id="element-1583">
                <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-1584">
                  <CalendarIcon className="w-5 h-5 text-black" data-id="element-1585" />
                </div>
                <div data-id="element-1586">
                  <p className="font-black text-white text-base md:text-lg" data-id="element-1587">
                    Paso 1
                  </p>
                  <p className="text-gray-300 text-sm md:text-base" data-id="element-1588">
                    Marca la fecha y hora en tu calendario ahora mismo
                  </p>
                </div>
              </div>

              {/* Step 2 */}
              <div className="flex items-start gap-4" data-id="element-1589">
                <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-1590">
                  <PhoneIcon className="w-5 h-5 text-black" data-id="element-1591" />
                </div>
                <div data-id="element-1592">
                  <p className="font-black text-white text-base md:text-lg" data-id="element-1593">
                    Paso 2
                  </p>
                  <p className="text-gray-300 text-sm md:text-base" data-id="element-1594">
                    Guarda este número en tu teléfono para no perder la llamada
                  </p>
                </div>
              </div>

              {/* Step 3 */}
              <div className="flex items-start gap-4" data-id="element-1595">
                <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-1596">
                  <MapPinIcon className="w-5 h-5 text-black" data-id="element-1597" />
                </div>
                <div data-id="element-1598">
                  <p className="font-black text-white text-base md:text-lg" data-id="element-1599">
                    Paso 3
                  </p>
                  <p className="text-gray-300 text-sm md:text-base" data-id="element-1600">
                    Busca un lugar tranquilo sin distracciones para la llamada
                  </p>
                </div>
              </div>

              {/* Step 4 */}
              <div className="flex items-start gap-4" data-id="element-1601">
                <div className="flex-shrink-0 w-10 h-10 bg-[#00f7fc] rounded-full flex items-center justify-center" data-id="element-1602">
                  <PenLineIcon className="w-5 h-5 text-black" data-id="element-1603" />
                </div>
                <div data-id="element-1604">
                  <p className="font-black text-white text-base md:text-lg" data-id="element-1605">
                    Paso 4
                  </p>
                  <p className="text-gray-300 text-sm md:text-base" data-id="element-1606">
                    Ten papel y lápiz listo para tomar notas importantes
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* TESTIMONIALS */}
        <section data-id="element-1607">
          <div className="text-center mb-8" data-id="element-1608">
            <div className="inline-flex items-center gap-2 bg-[#00f7fc]/10 border border-[#00f7fc]/30 rounded-full px-4 py-2 mb-4" data-id="element-1609">
              <QuoteIcon className="w-4 h-4 text-[#00f7fc]" data-id="element-1610" />
              <span className="text-sm font-semibold text-[#00f7fc] uppercase tracking-wide" data-id="element-1611">
                Lo Que Dicen Nuestros Estudiantes
              </span>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-5" data-id="element-1612">
            {/* Testimonial 1 */}
            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-6 flex flex-col" data-id="element-1613">
              <div className="flex gap-1 mb-4" data-id="element-1614">
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-1615" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-1616" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-1617" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-1618" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-1619" />
              </div>
              <QuoteIcon className="w-6 h-6 text-[#00f7fc]/40 mb-3" data-id="element-1620" />
              <p className="text-gray-300 text-sm leading-relaxed flex-1" data-id="element-1621">
                "El sistema es claro, paso a paso y fácil de implementar. Me
                ayudó a entender cómo usar la IA en mi negocio de una manera que
                nunca había pensado."
              </p>
              <div className="mt-4 pt-4 border-t border-gray-800" data-id="element-1622">
                <p className="font-bold text-white text-sm" data-id="element-1623">Carlos M.</p>
                <p className="text-gray-500 text-xs" data-id="element-1624">Miami, FL</p>
              </div>
            </div>

            {/* Testimonial 2 */}
            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-6 flex flex-col" data-id="element-1625">
              <div className="flex gap-1 mb-4" data-id="element-1626">
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-1627" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-1628" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-1629" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-1630" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-1631" />
              </div>
              <QuoteIcon className="w-6 h-6 text-[#00f7fc]/40 mb-3" data-id="element-1632" />
              <p className="text-gray-300 text-sm leading-relaxed flex-1" data-id="element-1633">
                "Lo que más me gustó fue lo práctico que es. No es teoría, es
                acción inmediata desde el primer día."
              </p>
              <div className="mt-4 pt-4 border-t border-gray-800" data-id="element-1634">
                <p className="font-bold text-white text-sm" data-id="element-1635">Maria G.</p>
                <p className="text-gray-500 text-xs" data-id="element-1636">Hialeah, FL</p>
              </div>
            </div>

            {/* Testimonial 3 */}
            <div className="bg-gray-900/60 border border-gray-800 rounded-xl p-6 flex flex-col" data-id="element-1637">
              <div className="flex gap-1 mb-4" data-id="element-1638">
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-1639" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-1640" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-1641" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-1642" />
                <StarIcon className="w-4 h-4 text-[#FDB931] fill-[#FDB931]" data-id="element-1643" />
              </div>
              <QuoteIcon className="w-6 h-6 text-[#00f7fc]/40 mb-3" data-id="element-1644" />
              <p className="text-gray-300 text-sm leading-relaxed flex-1" data-id="element-1645">
                "Nunca había usado IA para negocios. Ahora la uso todos los días
                y ha transformado completamente mi forma de trabajar."
              </p>
              <div className="mt-4 pt-4 border-t border-gray-800" data-id="element-1646">
                <p className="font-bold text-white text-sm" data-id="element-1647">Roberto S.</p>
                <p className="text-gray-500 text-xs" data-id="element-1648">Doral, FL</p>
              </div>
            </div>
          </div>
        </section>

        {/* CLOSING NOTE */}
        <section className="text-center pb-4" data-id="element-1649">
          <div className="inline-flex items-center gap-3 bg-[#00f7fc]/10 border border-[#00f7fc]/20 rounded-2xl px-6 py-4" data-id="element-1650">
            <CheckCircleIcon className="w-5 h-5 text-[#00f7fc] flex-shrink-0" data-id="element-1651" />
            <p className="text-gray-300 text-sm md:text-base" data-id="element-1652">
              Nos vemos en la llamada. Prepárate para tomar acción.
            </p>
          </div>
        </section>
      </main>

      <Footer data-id="element-1653" />
      <WhatsAppButton data-id="element-1654" />
    </div>;
}